module.exports = __webpack_public_path__ + "static/media/mb-square-logo.30699560.png";